/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Frontrow_InviteInputs */

const en_scene_frontrow_invite = /** @type {(inputs: Scene_Frontrow_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're invited to the February Market`)
};

/**
* | output |
* | --- |
* | "You're invited to the February Market" |
*
* @param {Scene_Frontrow_InviteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_frontrow_invite = /** @type {((inputs?: Scene_Frontrow_InviteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Frontrow_InviteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_frontrow_invite(inputs)
});